var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2295 0.75V8.25C10.2295 8.6875 9.88574 9 9.47949 9C9.04199 9 8.72949 8.6875 8.72949 8.25V2.5625L1.51074 9.78125C1.35449 9.9375 1.16699 10 0.979492 10C0.760742 10 0.573242 9.9375 0.448242 9.78125C0.135742 9.5 0.135742 9.03125 0.448242 8.75L7.66699 1.5H1.97949C1.54199 1.5 1.22949 1.1875 1.22949 0.75C1.22949 0.34375 1.54199 0 1.97949 0H9.47949C9.88574 0 10.2295 0.34375 10.2295 0.75Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.7820c010585f570b173ac28e0cc8c0c2.svg";
export { ForwardRef as ReactComponent };